import useSWR, { SWRResponse } from 'swr';
import { getAssignmentByProspectId } from '../../../providers/api/assignment/assignmentProvider';
import { Assignment } from '../../../providers/api/dtos/assignment';

export const ASSIGNMENT_BY_PROSPECT_ID_RID = '/api/v1/prospects/:id/assignment';

export default function useAssignmentByProspectId(prospectId?: string | null): SWRResponse<Assignment, Error> {
  return useSWR(prospectId ? [ASSIGNMENT_BY_PROSPECT_ID_RID, prospectId] : null, () => getAssignmentByProspectId(prospectId!));
}
